import type { OrderCardStop } from "@/lib/aiWidgetOrderParser"
import {
  formatClock,
  formatDay,
  formatWhen,
} from "../tachoCard/tachoCardFormat"
import type { OrderCardStrings } from "./orderCardStrings"

/** `Mon 27.10, 08:00–10:00`, or `Mon 27.10, 10:00` when only the end is planned. */
export function formatWindow(
  window: NonNullable<OrderCardStop["window"]>,
  t: OrderCardStrings,
): string {
  const { from, to } = window
  if (from === null) return formatWhen(to, t.weekdays)
  if (formatDay(from, t.weekdays) === formatDay(to, t.weekdays)) {
    return `${formatWhen(from, t.weekdays)}–${formatClock(to)}`
  }
  return `${formatWhen(from, t.weekdays)} – ${formatWhen(to, t.weekdays)}`
}

/** The ETA line of a stop the truck has not left, or null when there is no ETA. */
export function formatEta(
  stop: OrderCardStop,
  t: OrderCardStrings,
): string | null {
  if (stop.state === "done" || stop.eta === null) return null
  const label = stop.state === "here" ? t.hereSince : t.eta
  return `${label} ${formatWhen(stop.eta, t.weekdays)}`
}
